import React from 'react';
import { FlyoutMenu } from '.';
import { isMastheadCategoryMenu, isMastheadGalleryMenu, } from '../../../utils/contentful';
import { useActiveSubmenuContext, useActiveSubmenu, } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { useSubmenuItem } from '../../ActiveSubmenu/useSubmenuItem';
import { ContentfulCategoryMenu } from './MenuLayouts/CategoryMenu/ContentfulCategoryMenu';
import { ContentfulGalleryMenu } from './MenuLayouts/GalleryMenu/ContentfulGalleryMenu';
export var isFlyoutSubMenu = function (item) {
    return isMastheadCategoryMenu(item) || isMastheadGalleryMenu(item);
};
export var FlyoutSubmenu = function () {
    var activeSubmenu = useActiveSubmenuContext().activeSubmenu;
    var _a = useActiveSubmenu(activeSubmenu), claimActiveSubmenu = _a.claimActiveSubmenu, clearActiveSubmenu = _a.clearActiveSubmenu;
    var activeItem = useSubmenuItem(activeSubmenu);
    var opened = activeItem && isFlyoutSubMenu(activeItem);
    return (React.createElement(FlyoutMenu, { opened: opened, contentKey: activeItem ? activeItem === null || activeItem === void 0 ? void 0 : activeItem.sys.id : '', onClose: clearActiveSubmenu, onMouseEnter: function () {
            if (opened) {
                claimActiveSubmenu();
            }
        } },
        activeItem && isMastheadCategoryMenu(activeItem) && (React.createElement(ContentfulCategoryMenu, { activeItem: activeItem })),
        activeItem && isMastheadGalleryMenu(activeItem) && (React.createElement(ContentfulGalleryMenu, { activeItem: activeItem }))));
};
